import * as api from './api'

export default {
  async loadExtended (_, payload) {
    const { data } = await api.loadExtended(payload) || {}

    if (data?.code === 200) {
      return { data: data.data }
    }

    return { error: data?.code }
  },
}